module.exports = __webpack_public_path__ + "static/media/logo-no-background.4ea16d2a.svg";